import { render, staticRenderFns } from "./OriginalIdeals.vue?vue&type=template&id=1717b1de&scoped=true"
import script from "./OriginalIdeals.vue?vue&type=script&lang=ts"
export * from "./OriginalIdeals.vue?vue&type=script&lang=ts"
import style0 from "./OriginalIdeals.vue?vue&type=style&index=0&id=1717b1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1717b1de",
  null
  
)

export default component.exports